export const SET_TOP_BAR_TITLE = 'SET_TOP_BAR_TITLE';
export const LOGIN = 'login';
export const LOGOUT = 'logout';
export const GET_STATS = 'get_stats';
export const GET_STATS_SUCCESS = 'get_stats_success';
export const SET_RANGE = 'set_range';
export const GET_DASHBOARD_CUSTOMERS = 'GET_DASHBOARD_CUSTOMERS';
export const GET_DASHBOARD_CUSTOMERS_SUCCESS = 'GET_DASHBOARD_CUSTOMERS_SUCCESS';
export const GET_DASHBOARD_ORDERS = 'GET_DASHBOARD_ORDERS';
export const GET_DASHBOARD_ORDERS_SUCCESS = 'GET_DASHBOARD_ORDERS_SUCCESS';
export const GET_ORDERS = 'GET_ORDERS';
export const GET_ORDERS_SUCCESS = 'GET_ORDERS_SUCCESS';

export const LOGIN_SUCESS = 'LOGIN_SUCCCESS';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const LOGIN_LOADING = 'LOGIN_LOADING';
export const LOGIN_CLEAR_ERROR = 'LOGIN_CLEAR_ERROR';

export const LOGOUT_SUCESS = 'LOGOUT_SUCCCESS';
export const LOGOUT_ERROR = 'LOGOUT_ERROR';
export const LOGOUT_LOADING = 'LOGOUT_LOADING';

export const GET_RESTAURANTS_LOADING = 'GET_RESTAURANTS_LOADING';
export const GET_RESTAURANTS_SUCCESS = 'GET_RESTAURANTS_SUCCESS';
export const GET_RESTAURANTS_ERROR = 'GET_RESTAURANTS_ERROR';

export const SET_PRICE_GROUP = 'SET_PRICE_GROUP';



// WEBPACK FOOTER //
// ./src/actions/types.js